import getTiming from './getTiming';
export default function logTiming({ tuneInApiClient }) {
    const metrics = getTiming();
    if (metrics) {
        tuneInApiClient.logging.infoLog({
            message: 'timing',
            context: {
                metrics,
                pagePath: window.location.pathname,
            },
        });
    }
}
